import './App.scss';
import { Header, Footer, ErrorBoundary } from './components';
import { BrowserRouter } from 'react-router-dom';
import { SiteRoutes } from './config/Routes';
import 'swiper/scss';

function App() {
  return (
    <BrowserRouter>
      <Header />
      <ErrorBoundary>
        <SiteRoutes />
      </ErrorBoundary>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
